import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface DeleteShowParams {
  recitalId: string;
  showId: string;
}

export const deleteShowAPI = async ({
  recitalId,
  showId,
}: DeleteShowParams) => {
  const response = await baseAPI.delete(
    `/recitals/${recitalId}/shows/${showId}`,
  );
  return response.data;
};

export const useDeleteShowMutation = () => {
  return useMutation({
    mutationFn: async (params: DeleteShowParams) => {
      return await deleteShowAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId, KEYS.SHOWS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId, KEYS.STATS],
      });
    },
  });
};
